/**
 * Runtime config for the admin SPA.
 *
 * Defaults match the FeedbackHubStack outputs from Session 4 so a production build
 * works without a local .env. Override with VITE_* for another account or local API.
 *
 * Auth is native Cognito SRP (amazon-cognito-identity-js) against the IdP API directly --
 * there is no Cognito Hosted UI redirect, so the login form stays on this SPA's own origin
 * and browser password managers save credentials against that origin instead of
 * *.amazoncognito.com.
 */
export const config = {
  apiBaseUrl: (
    import.meta.env.VITE_API_BASE_URL ??
    "https://bnf3ygg5a9.execute-api.us-east-1.amazonaws.com"
  ).replace(/\/+$/, ""),
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? "us-east-1_raJeUwZBu",
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? "44rr1pb3ss0etkhv27rn78qqhj",
} as const;
